/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { AIGenerateBrandedNewIcon, CloseIcon, SettingsIcon } from '@coursera/cds-icons';
import { useTracker } from '@coursera/event-pulse/react';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';
import { useCoachChatContext } from 'bundles/ai-coach-platform/components/patterns/chat/context/CoachChatContext';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';

import _t from 'i18n!nls/xdp';

const styles = {
  container: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-200);
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  actionsContainer: css`
    display: flex;
    gap: var(--cds-spacing-50);
  `,
};

const TwoPanelChatHeader = () => {
  const { setCoachOpen, contextConfig } = useCoachState();
  const { openSettings } = useCoachChatContext();
  const track = useTracker();

  const handleSettings = () => {
    track('interact_coach', {
      coachInteractionType: 'coach_settings_open',
      coach: {
        mode: contextConfig.config.coachModeId,
      },
    });
    openSettings();
  };

  const handleClose = () => {
    track('interact_coach', {
      coachInteractionType: 'close_coach_tool',
      coach: {
        mode: contextConfig.config.coachModeId,
        location: 'toolbar',
      },
    });
    setCoachOpen(false);
  };

  const settingsLabel = _t('Settings');
  const closeLabel = _t('Close chat');

  return (
    <div css={styles.container}>
      <AIGenerateBrandedNewIcon size="large" aria-hidden="true" />
      <div css={styles.actionsContainer}>
        <CoachIconButton
          size="small"
          icon={<SettingsIcon color="default" />}
          aria-label={settingsLabel}
          tooltip={settingsLabel}
          tooltipPlacement="bottom"
          onClick={handleSettings}
          data-testid="coach-settings"
        />
        <CoachIconButton
          size="small"
          icon={<CloseIcon color="default" />}
          aria-label={closeLabel}
          tooltip={closeLabel}
          tooltipPlacement="bottom"
          onClick={handleClose}
          data-testid="coach-close"
        />
      </div>
    </div>
  );
};

export default TwoPanelChatHeader;
